<div class="contenedor" [ngClass]="{ difuminar_Fondo: !cargandoDatos }">
  <article class="article__info" [ngClass]="{'alert':this.currentSGRScoringState == 1}">
    <div *ngIf="!spinnerShow" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <section *ngIf="spinnerShow" class="info">
      <span class="span_header" matTooltip="Cliente rechazado SGR">
        <i-tabler *ngIf="this.currentSGRScoringState == 1" name="alert-triangle" style="color: red"
          >
          </i-tabler>
      </span>
      <h3 *ngIf="summaries" style="display: inline-block">
        {{ summaries!.name }}
        &nbsp;
      </h3>

      <div style="display: inline-block; vertical-align: text-top">
        <span
          *ngIf="
            myCompanyAssignment$ | async as myAssignment;
            else notAssignedCompany
          "
        >
          <span *ngIf="myAssignment && !loadingSpinner" class="span_header">
            <i-tabler
            *ngIf="myAssignment.executiveFactoring"
            class="icon-20"
            name="briefcase"
            matTooltip="
            {{ myAssignment.executiveFactoring }} - Factoring"
            >
            </i-tabler>
          </span>
          <span *ngIf="myAssignment && !loadingSpinner" class="span_header">
            <i-tabler
            *ngIf="myAssignment.executive"
            class="icon-20"
            name="briefcase"
            matTooltip="
            {{ myAssignment.executive }} - Garantias"
            >
            </i-tabler>
          </span>
          <span
            style="cursor: pointer"
            *ngIf="myAssignment && !loadingSpinner"
            (click)="markOrUnmark(myAssignment)"
            matTooltip="Favorito"
          >
            <i-tabler
              class="icon-20"
              name="star-filled"
              [ngStyle]="{ color: myAssignment.isFavorite ? 'orange' : 'gray' }"
            >
            </i-tabler>
          </span>
          <span *ngIf="loadingSpinner" class="span_header">
            <i-tabler class="icon-20" name="loader"> </i-tabler>
          </span>
        </span>
        <ng-template #notAssignedCompany>

          <span *ngIf="companyInfoPortafolio$ | async as assignment">
            <span  class="span_header">
              <i-tabler
              *ngIf="assignment.executiveFactoring"
              class="icon-20"
              name="briefcase"
              matTooltip="
              {{ assignment.executiveFactoring }} - Factoring"
              >
              </i-tabler>
            </span>
            <span  class="span_header">
              <i-tabler
              *ngIf="assignment.executive"
              class="icon-20"
              name="briefcase"
              matTooltip="
              {{ assignment.executive }} - Garantias"
              >
              </i-tabler>
            </span>
          </span>

          <span
            (click)="assignClientToMyPortfolio()"
            class="span_header"
            matTooltip="Agregar a Portafolio"
          >
            <i-tabler class="icon-20" name="folder-plus"> </i-tabler>
          </span>
        </ng-template>
        <span
          *ngIf="
            debtsCompanies != undefined &&
            debtsCompanies.isSiiConnected === true
          "
          (click)="openModalUpdateInvoces()"
          class="span_header"
          matTooltip="Actualizar Facts"
        >
          <i-tabler class="icon-20" name="refresh"> </i-tabler>
        </span>
        <span
          *ngIf="summaries?.debtorFavorite == true"
          class="span_header"
          matTooltip="Deudor Favorito"
        >
          <i-tabler class="icon-20" name="coin" style="color: orange">
          </i-tabler>
        </span>
        <span
          *ngIf="summaries?.isClient == true"
          class="span_header"
          matTooltip="Cliente"
        >
          <i-tabler class="icon-20" name="user"> </i-tabler>
        </span>
        <span
          *ngIf="summaries?.isDebtor == true"
          class="span_header"
          matTooltip="Deudor"
        >
          <i-tabler class="icon-20" name="coin"> </i-tabler>
        </span>
        <span
          *ngIf="summaries?.debtorBlackList == true"
          class="span_header"
          matTooltip="Deudor en Lista Negra"
        >
          <i-tabler class="icon-20" name="coin-off"> </i-tabler>
        </span>
      </div>

      <h4 style="margin-top: 0px; margin-bottom: 0px;"><span> &nbsp;&nbsp;&nbsp;&nbsp; {{ summaries?.rut }}</span></h4>

      <h3 *ngIf="summaries?.economicActivity">
        &nbsp;&nbsp;&nbsp;&nbsp;{{ summaries.economicActivity }}
      </h3>
      <h3 *ngIf="!summaries?.economicActivity">&nbsp;&nbsp;&nbsp;&nbsp;No presenta actividad</h3>

      <!--<div class="InfoExecutiveProtafolio">
        <span *ngIf="myCompanyAssignment$ | async as myAssignment" style="color: #003c8a;">
          <span *ngIf="myAssignment.executive">
            <i-tabler class="icon-20" name="briefcase"> </i-tabler>
            {{ myAssignment.executive }} - Garantias
          </span> <br>
          <span *ngIf="myAssignment.executiveFactoring">
            <i-tabler class="icon-20" name="briefcase"> </i-tabler>
            {{ myAssignment.executiveFactoring }} - Factoring</span>
        </span>
      </div>-->

    </section>
    <article *ngIf="spinnerShow" class="article__icons">
      <section class="section__title__icons">
        <div
          class="section__icons"
          *ngIf="
            summaries &&
            debtsCompanies != undefined &&
            debtsCompanies.isSiiConnected === false
          "
          (click)="updateSIIPass(summaries!.rut)"
        >
          Conectado
          <i-tabler
            [ngStyle]="{ color: 'red', cursor: 'pointer' }"
            class="icon-20"
            name="circle-filled"
          ></i-tabler>
        </div>

        <div
          class="section__icons"
          *ngIf="
            summaries &&
            debtsCompanies != undefined &&
            debtsCompanies.isSiiConnected === true
          "
        >
          Conectado
          <i-tabler
            [ngStyle]="{
              color: 'mediumspringgreen'
            }"
            class="icon-20"
            name="circle-filled"
          ></i-tabler>
        </div>
        <div
          class="section__icons"
          (click)="formTGR()"
          style="cursor: pointer"
          *ngIf="
            summaries &&
            debtsCompanies != undefined &&
            debtsCompanies.isSiiConnected === true
          "
        >
          TGR
          <div *ngIf="!tgrSpinnerShow; else spinner">
            <i-tabler
              [ngStyle]="{
                color:
                  debtsCompanies?.getTgr === 2
                    ? 'red'
                    : debtsCompanies?.getTgr === 1
                    ? 'mediumspringgreen'
                    : 'grey'
              }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
          </div>
        </div>
        <div
          class="section__icons"
          *ngIf="
            summaries &&
            debtsCompanies != undefined &&
            debtsCompanies.isSiiConnected === false
          "
        >
          TGR
          <div *ngIf="!tgrSpinnerShow; else spinner">
            <i-tabler
              [ngStyle]="{
                color:
                  debtsCompanies?.getTgr === 2
                    ? 'red'
                    : debtsCompanies?.getTgr === 1
                    ? 'mediumspringgreen'
                    : 'grey'
              }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
          </div>
        </div>
        <div
          class="section__icons"
          *ngIf="summaries"
          (click)="formDicom()"
          style="cursor: pointer"
        >
          DICOM
          <div *ngIf="!dicomSpinnerShow; else spinner">
            <i-tabler
              *ngIf="debtsCompanies != undefined"
              title="Monto Deuda: {{ deuda | currency : 'CLP' : 'symbol' }} "
              [ngStyle]="{
                color:
                  debtsCompanies.getDicom === 2
                    ? 'red'
                    : debtsCompanies.getDicom === 1
                    ? 'mediumspringgreen'
                    : 'grey'
              }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
            <i-tabler
              *ngIf="debtsCompanies === undefined"
              title="Monto Deuda: ${{ deuda }} "
              [ngStyle]="{ color: 'grey' }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
          </div>
        </div>
        <div
          class="section__icons"
          (click)="formCMF()"
          *ngIf="summaries"
          style="cursor: pointer"
        >
          CMF
          <div *ngIf="!cmfSpinnerShow; else spinner">
            <i-tabler
              [ngStyle]="{
                color:
                  debtsCompanies?.getCmf === 2
                    ? 'red'
                    : debtsCompanies?.getCmf === 1
                    ? 'mediumspringgreen'
                    : 'grey'
              }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
          </div>
        </div>
        <div
          (click)="refreshFogape()"
          class="section__icons"
          *ngIf="summaries"
          style="cursor: pointer"
        >
          Fogape
          <div *ngIf="!fogapeSpinnerShow; else spinner">
            <i-tabler
              [ngStyle]="{
                color:
                  fogapeClient?.hasFogape === false
                    ? 'red'
                    : fogapeClient?.hasFogape === true
                    ? 'mediumspringgreen'
                    : 'grey'
              }"
              class="icon-20"
              name="circle-filled"
            ></i-tabler>
          </div>
        </div>
      </section>
    </article>
  </article>
  <div class="spinner" *ngIf="!spinnerShow">
    <mat-spinner></mat-spinner>
  </div>

  <main *ngIf="spinnerShow" class="container_minutes_main">
    <app-filters-files-clients
      (topFilter)="filterTop($event)"
      (changeClientFileFilter)="receiveUpdatedFilters($event)"
    ></app-filters-files-clients>

    <article
      class="container_minutes_section"
      *ngIf="summaries"
      style="margin-top: -32px"
    >
      <div class="">
        <div class="row">
          <div class="col"><h3>Actividad Comercial</h3></div>
          <div class="col">
            <mat-button-toggle-group
              #group="matButtonToggleGroup"
              style="float: right"
              [value]="selectedVal"
              (change)="onValChange(group.value)"
            >
              <mat-button-toggle
                value="dashboard"
                (change)="onValChange($event.value)"
                matTooltip="Resumen"
              >
                <i-tabler class="toggle-icon" name="layout-grid"> </i-tabler>
              </mat-button-toggle>
              <mat-button-toggle
                (change)="onValChange($event.value)"
                value="chart"
                matTooltip="Gráfico"
              >
                <i-tabler class="toggle-icon" name="timeline"> </i-tabler>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="row" *ngIf="this.selectedVal == 'dashboard'">
          <div class="col">
            <section class="section__card cardWithShadow">
              <div class="container_fact_title">
                <h4>Fact Ventas</h4>
                <h3>
                  {{
                    summaries.sellInvoiceAmount | currency : "CLP" : "symbol"
                  }}
                </h3>
              </div>
              <div class="container_fact_title">
                <h4>Docs</h4>
                <h3>{{ summaries.numberSellInvoices }}</h3>
              </div>
            </section>
          </div>
          <div class="col">
            <section class="section__card cardWithShadow">
              <div class="container_fact_title">
                <h4>NC Ventas</h4>
                <h3>
                  {{
                    summaries.sellCreditNotesAmount
                      | currency : "CLP" : "symbol"
                  }}
                </h3>
              </div>
              <div class="container_fact_title">
                <h4>Docs</h4>
                <h3>{{ summaries.numberSellCreditNotes }}</h3>
              </div>
            </section>
          </div>
          <div class="col">
            <section class="section__card cardWithShadow">
              <div class="container_fact_title">
                <h4>Fact Compras</h4>
                <h3>
                  {{ summaries.buyInvoiceAmount | currency : "CLP" : "symbol" }}
                </h3>
              </div>
              <div class="container_fact_title">
                <h4>Docs</h4>
                <h3>{{ summaries.numberBuyInvoices }}</h3>
              </div>
            </section>
          </div>
          <div class="col">
            <section class="section__card cardWithShadow">
              <div class="container_fact_title">
                <h4>NC Compras</h4>
                <h3>
                  {{
                    summaries.buyCreditNotesAmount | currency : "CLP" : "symbol"
                  }}
                </h3>
              </div>
              <div class="container_fact_title">
                <h4>Docs</h4>
                <h3>{{ summaries.numberBuyCreditNotes }}</h3>
              </div>
            </section>
          </div>
          <!-- <div class="col-2">
      <section class="section__card cardWithShadow">
        <app-line-detail-chart
          [companyLineSummary]="companyLineSummary"
        ></app-line-detail-chart>
      </section>
    </div> -->
        </div>
        <div class="row" *ngIf="this.selectedVal == 'chart'">
          <div class="col">
            <app-activity-summary-chart
              [dataSource]="this.monthlySummaries"
            ></app-activity-summary-chart>
          </div>
        </div>
      </div>
    </article>
    <article>
      <mat-card class="container_tab">
        <mat-card-content
          class="b-t-1 swipe-container"
          (touchstart)="touchStart($event)"
          (touchmove)="touchMove($event)"
          (touchend)="touchEnd()"
        >
          <mat-tab-group 
            (selectedTabChange)="setPowerBiFrame($event)"
            [(selectedIndex)]="selectedIndex"
          >
            <mat-tab label="Informacion">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <app-information
                  (sendBoolean)="receiveBooelan($event)"
                  [portafolio]="companyInfoPortafolio$ | async"
                  [fogapeInfo]="fogapeClient"
                  [receiveBooleanOwners]="updateOwner"
                  (SGRScoringState)="receiveSGRScoringState($event)"
                  >
                  </app-information>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Documentos">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <app-company-documents-section
                    [companyId]="this.rutUrl"
                  ></app-company-documents-section>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Deudores">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <div *ngIf="deptors$ | async as debtors; else tabSpinner">
                    <app-debtor-information
                      (sendfilterTop)="filterTop($event)"
                      (debtorCompanyIdToViewRelationship)="
                        receiveDebtorCompanyIdToViewRelationship($event)
                      "
                      [deptors]="debtors"
                    >
                    </app-debtor-information>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <!-- <mat-tab label="Riesgo" >
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <h3>Proximamente</h3>
              </div>
            </mat-tab> -->
            <mat-tab label="Facturas">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <mat-tab-group mat-stretch-tabs
                  (touchstart)="stopPropagation($event)"
                  (touchmove)="stopPropagation($event)"
                  (touchend)="stopPropagation($event)">
                    <mat-tab label="Ventas">
                      <ng-template matTabContent>
                        <div>
                          <app-fact-docs-client
                            *ngIf="
                              resultsInvoice$ | async as sellInvoices;
                              else tabSpinner
                            "
                            [resultsInvoice]="sellInvoices"
                            [requestInvoice]="requestInvoice"
                            [sortOrder]="sellInvoiceSort"
                            (pages)="filterPageSize($event)"
                            (viewInvoiceBuyOrder)="
                              openViewInvoiceBuyOrder($event)
                            "
                            (changeSortOrder)="
                              receiveChangeSellInvoicesOrder($event)
                            "
                            (operationBoolean)="receiveBoolean($event)"
                            (viewRelationWithClient)="
                              receiveDebtorCompanyIdToViewRelationship($event)
                            "
                          >
                          </app-fact-docs-client>
                        </div>
                      </ng-template>
                    </mat-tab>
                    <mat-tab label="Factorizadas">
                      <ng-template matTabContent>
                        <div>
                          <app-invoce-sell-factoring
                            *ngIf="
                              buyInvocesFact$ | async as buyInvocesFactoring;
                              else tabSpinner
                            "
                            [resultsInvoice]="buyInvocesFactoring"
                            [requestInvoice]="requestInvoice"
                            (pages)="filterPageSize($event)"
                            (changePagination)="
                              receiveChangeBuyInvoiceFactoringPagination($event)
                            "
                          >
                          </app-invoce-sell-factoring>
                        </div>
                        <div
                          *ngIf="
                            cesionarios$ | async as cesionarios;
                            else tabSpinner
                          "
                        >
                          <app-client-cesionarios-table
                            (changePagination)="
                              receiveChangeCesionarioPagination($event)
                            "
                            (changeSortOrder)="
                              receiveChangeCesionarioOrder($event)
                            "
                            [cesionariosPaged]="cesionarios"
                          ></app-client-cesionarios-table>
                        </div>
                      </ng-template>
                    </mat-tab>
                    <mat-tab label="Compras">
                      <ng-template matTabContent>
                        <div>
                          <app-client-buy-invoices
                            *ngIf="
                              buyInvoices$ | async as buyInvoices;
                              else tabSpinner
                            "
                            (changePagination)="
                              receiveChangeBuyInvoicePagination($event)
                            "
                            (changeSortOrder)="
                              receiveChangeBuyInvoicesOrder($event)
                            "
                            [result]="buyInvoices"
                            (viewRelationWithClient)="
                              receiveDebtorCompanyIdToViewRelationship($event)
                            "
                          >
                          </app-client-buy-invoices>
                        </div>
                      </ng-template>
                    </mat-tab>
                  </mat-tab-group>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Notas Crédito">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <div
                    *ngIf="
                      creditNotesResponse$ | async as pagedCreditNotes;
                      else tabSpinner
                    "
                  >
                    <app-client-credit-notes-table
                      (changePagination)="
                        receiveChangeCreditNotePagination($event)
                      "
                      (changeSortOrder)="receiveChangeCreditNotesOrder($event)"
                      [pagedResult]="pagedCreditNotes"
                    >
                    </app-client-credit-notes-table>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Op. Factoring">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <div
                    *ngIf="operations$ | async as operations; else tabSpinner"
                  >
                    <app-invoice-operations
                      [rutUrl]="rutUrl"
                      [operations]="operations"
                      [operationsApproved]="operationsApproved"
                    ></app-invoice-operations>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Op. Garantías">
              <ng-template matTabContent>
                <mat-tab-group>
                  <mat-tab label="Emitidas">
                    <ng-template matTabContent>
                      <div
                        *ngIf="
                          warranties$ | async as warranties;
                          else tabSpinner
                        "
                      >
                        <app-general-table
                          [rowEvents]="warrantyRowEvents"
                          [noContentMessage]="'Sin Garantías'"
                          [columnsConfiguration]="warrantyTableColsConfig"
                          [dataSource]="warranties"
                        >
                        </app-general-table>
                      </div>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="En espera de pago">
                    <ng-template matTabContent>
                      <div
                        *ngIf="
                          awaitingPaymentWarranties$
                            | async as awaitingPaymentWarranties;
                          else tabSpinner
                        "
                      >
                        <app-general-table
                          [rowEvents]="warrantyRowEvents"
                          [noContentMessage]="'Sin Garantías'"
                          [columnsConfiguration]="
                            tableSettings.awatingPaymentColumn
                          "
                          [dataSource]="awaitingPaymentWarranties"
                        ></app-general-table>
                      </div>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Pendientes">
                    <ng-template matTabContent>
                      <div class="mat-body-1 p-16 rounded m-t-12">
                        <div
                          *ngIf="
                            pendingApproveWarranties$
                              | async as pendingWarranties;
                            else tabSpinner
                          "
                        >
                          <app-client-pending-warranties-table
                          (warrantyToUpdateAmount)="openUpdateWarrantyAmount($event)"
                            (warrantiesForMinute)="
                              createMinuteWithWarranties($event)
                            "
                            (sendBoolean)="receiveBooleanWarrantiyes($event)"
                            [pendingWarranties]="pendingWarranties"
                            [currentSGRScoringState]="currentSGRScoringState"
                          >
                          </app-client-pending-warranties-table>
                        </div>
                      </div>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Cotizaciones">
                    <ng-template matTabContent>
                      <div class="mat-body-1 p-16 rounded m-t-12">
                        <div>
                          <app-view-simulations-client [companyId]="rutUrl" [search]="fileClientFilter.search"
                          ></app-view-simulations-client>
                        </div>
                      </div>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
              </ng-template>
            </mat-tab>
            <mat-tab label="Minutas">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <div *ngIf="minutes$ | async as minutes; else tabSpinner">
                    <app-table-minutes
                      [rut]="summaries?.rut"
                      [minutes]="minutes"
                      (viewRegisterMinute)="openViewRegisterMinutes()"
                    >
                    </app-table-minutes>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Actividad">
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <ng-template matTabContent>
                  <div>
                    <app-activity [companyId]="rutUrl"></app-activity>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <!-- <mat-tab label="PowerBi">
              <div id="PowerBiFrameDiv" class="bg-light-primary rounded">
                <iframe
                  id="powerBiFrame"
                  title="DatosFactoring_embedded"
                  width="1140"
                  height="541.25"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              </div>
            </mat-tab> -->
            <!--
            <mat-tab label="Ventas"
              ><div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                Ventas
              </div></mat-tab
            >
            <mat-tab label="Compras"
              ><div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                Compras
              </div></mat-tab
            >
           -->
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </article>
    <section>
      <button
        class="d-flex align-items-center m-y-32"
        type="button"
        mat-stroked-button
        color="primary"
        onclick="history.back()"
      >
        <span class="span_back">
          <i-tabler name="chevron-left" class="m-r-8"></i-tabler>
          <span>Volver</span>
        </span>
      </button>
    </section>
  </main>
  <ng-template #spinner>
    <div>
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  </ng-template>

  <ng-template #tabSpinner>
    <div class="tab-spinner-section">
      <mat-spinner diameter="70"></mat-spinner>
    </div>
  </ng-template>
</div>
